import styles from './SystemDiagram.module.scss';

import React, { FC, useRef } from 'react';

import { SystemDiagram } from 'api/contentful/contentTypes.cloverdotcom';
import { FadeToastUp } from 'components/Animation/FadeToastUp/FadeToastUp';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';
import { SubjectMedia } from 'components/SubjectMedia/SubjectMedia';
import { Tabs } from 'components/Tabs/Tabs';
import { TextV2 } from 'components/TextV2/TextV2';
import { FlatEntry } from 'services/cms/flattenContentful';
import { AppType } from 'services/cms/typesUtil';

export type SystemDiagramProps = AppType.Component<FlatEntry<SystemDiagram>>;

export const SystemDiagramModule: FC<SystemDiagramProps> = ({
  _attributes,
  headingTagName,
  item,
  softwarePlanTabLabel,
  systemOverviewTabLabel,
  title,
}) => {
  const { current: tablistId } = useRef(`system-diagram-${Date.now()}`);

  const tabItems = [
    {
      tab: `${systemOverviewTabLabel}`,
      tabPanel: (
        <div className={styles.tabPanel}>
          <SubjectMedia entry={item} playWhenInView loop />
        </div>
      ),
    },
    {
      tab: `${softwarePlanTabLabel}`,
      tabPanel: (
        <div className={styles.tabPanel}>
          <TextV2 className={styles.eyebrow} variant="modern-eyebrow" value={item?.subTitle} />
          <TextV2 className={styles.title} variant="modern-h3" value={item?.title} />
          <RichBlurb className={styles.richBlurb} document={item?.richBlurb} noMarginGap />
        </div>
      ),
    },
  ];

  return (
    <section className={styles.systemDiagramWrapper} {..._attributes}>
      <FadeToastUp>
        <TextV2
          id={tablistId}
          className={styles.title}
          variant="modern-h2"
          value={title}
          tagName={headingTagName}
        />
      </FadeToastUp>
      <FadeToastUp>
        <Tabs tablistId={tablistId} items={tabItems} variant="pill" />
      </FadeToastUp>
    </section>
  );
};

export default SystemDiagramModule;
